"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Swarm = void 0;
var Unit_1 = require("../Unit");
var particle_emitter_1 = require("@pixi/particle-emitter");
var deathFX_1 = require("../../VFX/deathFX");
var app_1 = require("../../app");
/**
 * Let's add some object pooling to reduce the workload of creating and destroying units
 * make it optional, and set multiple pools for types of minions
 */
var Swarm = function () {
    var id = 0;
    var units = [];
    var addUnit = function (unitName, position) {
        if (position === void 0) { position = { x: 0, y: 0 }; }
        var particleContainer = app_1.appService.particleContainer;
        var unit = (0, Unit_1.createUnit)("".concat(unitName, "-").concat(id++), unitName, position);
        units.push(unit);
        unit.health.subscribeToDeath(function () {
            var emitter = new particle_emitter_1.Emitter(particleContainer, (0, deathFX_1.explode)({ x: unit.sprite.x, y: unit.sprite.y }));
            emitter.playOnceAndDestroy();
            removeUnit(unit.id);
        });
        return unit;
    };
    var removeUnit = function (id) {
        var unit = getUnitById(id);
        unit.sprite.destroy();
        var i = units.findIndex(function (u) { return u.id === id; });
        units.splice(i, 1);
    };
    var getUnitById = function (id) {
        return units.find(function (unit) { return unit.id === id; });
    };
    var getClosestUnit = function (_a) {
        var x = _a.x, y = _a.y;
        var closestDistanceSq = Infinity;
        return units.reduce(function (closestUnit, currentUnit, i) {
            var distance = Math.pow((currentUnit.sprite.x - x), 2) + Math.pow((currentUnit.sprite.y - y), 2);
            if (distance < closestDistanceSq) {
                closestUnit = currentUnit;
            }
            return closestUnit;
        }, null);
    };
    var getFirstUnitWithin = function (position, range) { };
    return {
        units: units,
        addUnit: addUnit,
        removeUnit: removeUnit,
        getUnitById: getUnitById,
        getClosestUnit: getClosestUnit,
    };
};
exports.Swarm = Swarm;
